// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Legend_wrapper__9ujhm","text":"Legend_text__8c1jh"};